
export default {
  name: 'MegasredaContentEventsGridCard',
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isSetShow: false,
    }
  },
  computed: {
    author() {
      const author = Array.isArray(this.product?.author)
        ? this.product?.author[0]
        : this.product?.author
      return author
    },
    startDate() {
      if (this.product?.date?.startDate) {
        const date = this.$dayjs(this.product.date.startDate).format(
          'DD MMMM YYYY в HH-mm'
        )
        return date
      } else {
        return null
      }
    },
    provisionType() {
      return this.product.provisionType === 'ONLINE' ? `Онлайн` : `Офлайн`
    },
  },
  methods: {
    inView({ isInView }) {
      if (isInView && !this.isSetShow) {
        this.setShow()
      }
    },
    setShow() {
      this.$axios.$post('/activity/show/advertisement', {
        username: this.author.username,
        advertisementId: this.product._id,
      })
      this.isSetShow = true
    },
  },
}
